import React, { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Logout = () => {
  const { logout } = useAuth0();

  // prevents double logout trigger in StrictMode
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (!hasLoggedOut.current) {
      hasLoggedOut.current = true;

      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    }
  }, [logout]);

  return <p>Logging out...</p>;
};

export default Logout;
